import 'javascript/vendor/initialisers.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'javascript/analytics/sentry';

import '@hotwired/turbo-rails';

import 'javascript/compatibility/polyfills';
import { Application } from 'stimulus';

import 'javascript/analytics/google_analytics_tracking';

import { registerStimulusControllers } from 'javascript/utils/utils';

const application = Application.start();

import {
  onTurboBeforeVisit,
  onTurboSubmitStart,
  onAnchorClicked,
  onTurboLoad,
} from 'javascript/utils/turbolinks_polyfills';

$(document).on('click', onAnchorClicked);
$(document).on('turbo:before-visit', onTurboBeforeVisit);
$(document).on('turbo:submit-start', onTurboSubmitStart);
$(document).on('turbo:load', onTurboLoad);

const sharedControllers = import.meta.glob('javascript/controllers/shared/*', {
  eager: true,
});
registerStimulusControllers({
  controllers: sharedControllers,
  portal: 'shared',
  application,
});

const organiserControllers = import.meta.glob(
  'javascript/controllers/organiser_portal/*',
  {
    eager: true,
  },
);
registerStimulusControllers({
  controllers: organiserControllers,
  portal: 'organiser_portal',
  application,
});
